import React from "react"

export const IsOnlineContext = React.createContext({
  isOnline: false as boolean
});
